import {
  NOTE_PREVIEW_DIVIDER_COLOR,
  NOTE_PREVIEW_EMR_LOGO,
  NOTE_PREVIEW_FOOTER_LOGO_HEIGHT_PX,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_MUTED_COLOR,
} from "../note-preview-constant";
import { NotePreviewFooterInfo } from "../note-preview-types";

export interface ReportFooterProps {
  footer: NotePreviewFooterInfo;
}

const ReportFooter = ({ footer }: ReportFooterProps) => (
  <footer
    style={{
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
      marginTop: 20,
      paddingTop: 6,
      borderTop: `1px dashed ${NOTE_PREVIEW_DIVIDER_COLOR}`,
      fontSize: 10,
      color: NOTE_PREVIEW_MUTED_COLOR,
      breakInside: "avoid",
    }}
  >
    {footer.showEmrLogo && (
      <img
        src={NOTE_PREVIEW_EMR_LOGO}
        alt={NOTE_PREVIEW_LABELS.emrLogoAlt}
        style={{
          height: NOTE_PREVIEW_FOOTER_LOGO_HEIGHT_PX,
          objectFit: "contain",
        }}
      />
    )}
    <div style={{ flex: 1, lineHeight: 1.5 }}>
      <div>
        {NOTE_PREVIEW_LABELS.patient} : {footer.patientLine}
      </div>
      <div>
        {NOTE_PREVIEW_LABELS.dos} : {footer.dosLine}
      </div>
      {footer.helpLine && <div>{footer.helpLine}</div>}
    </div>
    <div>{footer.version}</div>
  </footer>
);

export default ReportFooter;
